<template>
  <BaseGroupExpansionPanels
    :tile-title="displayTileTitle"
    :tile-sub-title="displayTileSubTitle"
    :tile-trailing-text="displayTrailingText"
    :on-selection-change="updateSelection"
    :is-group-selected="isGroupSelected"
    :selected-grouping-data="groupedWithRanges"
  >
    <template #expansion-panel-content="{ group }">
      <div class="mt-2">
        <div class="subtitle-1 mb-2">
          All Occurrences:
        </div>

        <v-container
          class="pa-0"
          style="
            background-color: azure;
            max-height: 15em;
            overflow-y: auto;
            padding: 0px;
            border: 2px solid #e0e0e0;
            border-radius: 0.8em;
          "
        >
          <v-list
            dense
            class="pa-0"
          >
            <v-list-item
              v-for="range in group.ranges"
              :key="range.startDate + range.endDate"
            >
              <v-list-item-content>
                <v-row class="align-center">
                  <v-col cols="10">
                    {{
                      range.startDate === range.endDate
                        ? formatDate(range.startDate)
                        : formatDate(range.startDate) +
                          " - " +
                          formatDate(range.endDate)
                    }}
                    -
                    {{ group.notifications[0].vesselName }}
                  </v-col>

                  <v-col cols="2">
                    <v-checkbox
                      dense
                      :input-value="
                        range.notifications.every(n =>
                          selectedNotifications.includes(n)
                        )
                      "
                      @change="toggleRange(range)"
                    />
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-container>
      </div>
    </template>
  </BaseGroupExpansionPanels>
</template>

<script>
import BaseGroupExpansionPanels from "./BaseGroupExpansionPanels.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "GroupByRule",

  components: {
    BaseGroupExpansionPanels,
  },

  computed: {
    ...mapState("notifications", ["selectedNotifications"]),
    ...mapGetters("notifications", ["groupedNotificationsByRule"]),

    //  Build day ranges from real notifications
    groupedWithRanges() {
      return this.groupedNotificationsByRule.map((group) => ({
        ...group,
        ranges: this.groupConsecutiveDates(group.notifications)
      }));
    },

    selectedNotificationsModel: {
      get() {
        return this.selectedNotifications;
      },
      set(value) {
        this.$store.commit(
          "notifications/SET_SELECTED_NOTIFICATIONS",
          value
        );
      },
    },
  },

  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },

    //  Group consecutive days
    groupConsecutiveDates(notifications) {
      if (!notifications || !notifications.length) return [];

      // collapse same-day duplicates
      const byDay = {};

      notifications.forEach((n) => {
        const day = new Date(n.checkDate)
          .toISOString()
          .substring(0, 10);

        if (!byDay[day]) {
          byDay[day] = {
            startDate: day,
            endDate: day,
            notifications: [n]
          };
        } else {
          byDay[day].notifications.push(n);
        }
      });

      const uniqueDays = Object.values(byDay);

      // sort ascending
      uniqueDays.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate)
      );

      const ranges = [];
      let current = { ...uniqueDays[0] };

      for (let i = 1; i < uniqueDays.length; i++) {
        const diffDays =
          (new Date(uniqueDays[i].startDate) -
            new Date(current.endDate)) /
          (1000 * 60 * 60 * 24);

        if (Math.round(diffDays) === 1) {
          current.endDate = uniqueDays[i].startDate;
          current.notifications.push(
            ...uniqueDays[i].notifications
          );
        } else {
          ranges.push(current);
          current = { ...uniqueDays[i] };
        }
      }

      ranges.push(current);

      // newest first
      return ranges.reverse();
    },

    toggleRange(range) {
      const allSelected = range.notifications.every((n) =>
        this.selectedNotifications.includes(n)
      );

      if (allSelected) {
        this.$store.commit(
          "notifications/REMOVE_SELECTED_NOTIFICATIONS",
          range.notifications
        );
      } else {
        this.$store.commit(
          "notifications/ADD_SELECTED_NOTIFICATIONS",
          range.notifications
        );
      }
    },

    updateSelection(value, group) {
      const notifications = group.notifications;

      if (value) {
        this.$store.commit(
          "notifications/ADD_SELECTED_NOTIFICATIONS",
          notifications
        );
      } else {
        this.$store.commit(
          "notifications/REMOVE_SELECTED_NOTIFICATIONS",
          notifications
        );
      }
    },

    isGroupSelected(group) {
      return group.notifications.every((notification) =>
        this.selectedNotifications.includes(notification)
      );
    },

    displayTileTitle(group) {
      return group.alertRule.summary;
    },

    displayTileSubTitle(group) {
      if (!group.notifications.length) return "";
      return group.notifications[0].vesselName;
    },

    displayTrailingText(group) {
      return `Last: ${this.formatDate(group.latestDate)}`;
    },
  },
};
</script>
